<mat-card>
    <mat-card-header class="se-dialog-header">
        <mat-card-title>
            <h4 translate>{{ data.header }}</h4>
        </mat-card-title>
    </mat-card-header>

    <mat-card-content>
        @if (data.enableSearch) {
            <form (keyup.enter)="onSearch()" class="add-exam-form">
                <mat-form-field>
                    <input
                        matInput
                        name="surname"
                        [placeholder]="'LastName' | translate"
                        [(ngModel)]="examToSearch.surname"
                    />
                </mat-form-field>

                <mat-form-field>
                    <input
                        matInput
                        name="name"
                        [placeholder]="'FirstName' | translate"
                        [(ngModel)]="examToSearch.name"
                    />
                </mat-form-field>

                <mat-form-field>
                    <input
                        matInput
                        name="date"
                        [matDatepicker]="picker"
                        [placeholder]="'ExamDate' | translate"
                        [(ngModel)]="examToSearch.date"
                    />

                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>

                    <mat-datepicker #picker></mat-datepicker>

                    <button matSuffix mat-icon-button type="button" tabIndex="-1" (click)="onResetDate()">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>

                <button mat-icon-button [class.add-exam-part-disabled]="loading" (click)="onSearch()">
                    @if (loading) {
                        <mat-icon>hourglass_empty</mat-icon>
                    } @else {
                        <mat-icon>search</mat-icon>
                    }
                </button>
            </form>
        }

        <div class="grid-wrapper">
            <ag-grid-angular
                #datagrid
                class="worklist-grid"
                [gridOptions]="gridOptions"
                [rowData]="items"
                (gridReady)="onGridReady($event)"
                [loading]="false"
                [modules]="agGridModuls"
                [theme]="agGridTheme"
            >
            </ag-grid-angular>

            @if (loading) {
                <div class="loading-overlay">
                    <mat-spinner diameter="50"></mat-spinner>
                </div>
            }
        </div>

        <div class="error-message mat-body-medium">
            {{ message }}
        </div>
    </mat-card-content>

    <mat-card-actions align="end">
        <button mat-button [class.add-exam-part-disabled]="!canAdd()" (click)="_checkAddFnToUse()">
            <p translate>AddExam</p>
        </button>

        <button mat-button (click)="onClose()">
            <p translate>Cancel</p>
        </button>
    </mat-card-actions>
</mat-card>
